import { api } from './client'

export type StaffUser = {
  id: string
  username: string
  email: string
  firstname: string
  lastname: string
  roles: string[]
  active: boolean
  mfa_enrolled: boolean
  must_change_password: boolean
  last_login?: string | null
  created_at?: string | null
}

export type Role = {
  id: string
  name: string
  description: string
  system: boolean
  permissions: string[]
  member_count: number
  created_at?: string | null
}

export type Permission = { id: string; name: string; description: string }

// ---- users -----------------------------------------------------------------

export const listUsers = () => api.get<StaffUser[]>('/admin/users')

export type InviteResult = { user: StaffUser; temporary_password: string }
export const inviteUser = (body: { email: string; firstname: string; lastname: string; role: string; username?: string }) =>
  api.post<InviteResult>('/admin/users', body)

export const updateUser = (id: string, body: { firstname?: string; lastname?: string; active?: boolean; role?: string }) =>
  api.patch<{ ok: boolean }>(`/admin/users/${id}`, body)

export const resetUserMfa = (id: string) => api.post<{ ok: boolean }>(`/admin/users/${id}/reset-mfa`)

export const resetUserPassword = (id: string) =>
  api.post<{ temporary_password: string }>(`/admin/users/${id}/reset-password`)

// ---- roles & permissions ---------------------------------------------------

export const listRoles = () => api.get<Role[]>('/admin/roles')
export const listPermissions = () => api.get<Permission[]>('/admin/permissions')

export const createRole = (body: { name: string; description: string; permissions: string[] }) =>
  api.post<{ id: string }>('/admin/roles', body)

export const updateRole = (id: string, body: { name?: string; description?: string; permissions?: string[] }) =>
  api.patch<{ ok: boolean }>(`/admin/roles/${id}`, body)

export const deleteRole = (id: string) => api.del<{ ok: boolean }>(`/admin/roles/${id}`)

// ---- audit -----------------------------------------------------------------

export type AuditRow = {
  id: string
  actor_email: string
  action: string
  model?: string | null
  model_id?: string | null
  detail: string
  ip: string
  at: string
}
export const listAuditLog = (limit = 50) => api.get<AuditRow[]>(`/admin/audit-log?limit=${limit}`)
